import React from 'react';
import './footer.css';

const Footer=()=>{


    return(
        <div>
        <div className='footer_page'>
            <div>
                <table>
                    <tr>
                        <th >
                            <h3>Get to Know Us</h3>

                            <p>About us</p>
                            <p>Careers</p>
                            <p>Press Releases</p>
                            <p>Amazon Cares</p>
                            <p>Gift a Smile</p>
                            <p>Amazon Science</p>

                        </th>

                        <th >
                            <h3>Connect with Us</h3>
                            <p>Facebook</p>
                            <p>Twitter</p>
                            <p>instragram</p>
                        </th>
                        <th >
                            <h3>Make Money with Us</h3>
                            <p>Sell on Amazon</p>
                            <p>Become an Affiliate</p>
                            <p>Advertise Your Products</p>
                            <p>Amazon Pay on Merchants</p>
                        </th>
                        <th >
                            <h3>Let Us Help You</h3>
                            <p>COVID-19 and Amazon</p>
                            <p>Your Account</p>
                            <p>Returns Center</p>
                            <p>100% Purchase Protection</p>
                            <p>Amazon App Download</p>
                            <p>Amazon Assistant Download</p>
                            <p>Help</p>
                        </th>
                    </tr>
                </table>
                
            </div>
        </div>
        <hr />
        <div className='footer_last'>
            <h1 >Amazon</h1>
        </div>
        </div>
    );

};
export default Footer;